// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TmOc","col":"styles_col__1vTg2"};